import { render } from "./ComponenteDatosEconomicos.vue?vue&type=template&id=68a79450&scoped=true"
import script from "./ComponenteDatosEconomicos.vue?vue&type=script&lang=js"
export * from "./ComponenteDatosEconomicos.vue?vue&type=script&lang=js"

import "./ComponenteDatosEconomicos.vue?vue&type=style&index=0&id=68a79450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a79450"]])

export default __exports__